import { isSameDay } from 'date-fns';
import {
  CalendarLead,
  StackedCalendarMode,
} from 'pages/virtualizedStackedCalendar/Calendar.types';
import {
  getLeadColor,
  getLeadCheckInDate,
  getLeadCheckOutDate,
  getOpacity,
  getZIndexFromLeadSource,
} from 'utils/lead/leadUtils';
import { classNames } from 'utils/classNameUtils';
import { DayCellLeadContainer } from './StackedCalendarDays.styles';

const DayCellLead = ({
  width,
  dayDate,
  lead,
  mode,
}: {
  width: number;
  dayDate: Date;
  lead: CalendarLead;
  mode: StackedCalendarMode;
}) => {
  const isCheckInDay = isSameDay(getLeadCheckInDate(lead), dayDate);
  const isCheckOutDay = isSameDay(getLeadCheckOutDate(lead), dayDate);

  const opacity = getOpacity(lead.status);
  const color = getLeadColor(mode, lead);
  const zIndex = getZIndexFromLeadSource(lead.source, lead.status);

  return (
    <DayCellLeadContainer
      className={classNames({
        'check-in': isCheckInDay,
        'check-out': isCheckOutDay,
      })}
      isCheckInDay={isCheckInDay}
      isCheckOutDay={isCheckOutDay}
      $background={color}
      $opacity={opacity}
      $width={width}
      $zIndex={zIndex}
      data-lead-uid={lead.uid}
    />
  );
};

export default DayCellLead;
